var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "m7 11l5-5l5 5M7 17l5-5l5 5"
    }, null, -1)
  ]));
}
__name(render, "render");
const chevronsUp = markRaw({ name: "tabler-chevrons-up", render });
export {
  chevronsUp as default
};
//# sourceMappingURL=chevrons-up.js.map
